import classes from "./StatusTag.module.css";

/** The statuses the stage's cards show, each in the app's own color for it,
    except where the page's color rules override the app's. */
export const TAG_TONE = {
  DECIDED: "decided",
  OPEN: "open",
  PROPOSED: "proposed",
  CONFIRMED: "confirmed",
  /** Retired, and Declined, which the app draws red: red is only for the
      recording dot and Leave on this page. */
  SETTLED: "settled",
  /** A rule's kind, beside its status once it is confirmed. */
  KIND: "kind",
} as const;
export type TagTone = (typeof TAG_TONE)[keyof typeof TAG_TONE];

/** A status as the stage's cards set it: small mono capitals in a dashed box. */
export default function StatusTag({ tone, children }: { tone: TagTone; children: string }) {
  return (
    <span className={classes.tag} data-tone={tone}>
      {children}
    </span>
  );
}
